module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product22-a6dbedb6912e282e4d9da582b57a584a.jpg";